import { observable, action } from "mobx";
import { ajax } from "@src/utils";
import { IOrderInfo } from "@src/entity/payment/order";

class Order {
  @observable
  orderList: IOrderInfo[] = [];
  @observable
  orderLoading = "init";
  @action.bound
  async getOrderList(orderNo: string[]) {
    this.orderLoading = "pending";
    let res;
    if (orderNo.length === 0) {
      res = await [];
      this.orderList = res;
      this.orderLoading = "done";
    } else {
      res = await ajax.getJsonWithToken(`/oc/v1.0/orders/list`, {
        orderNoList: orderNo.join(","),
      });
      this.orderLoading = "done";
      if (+res.code === 0) {
        this.orderList = res.content.data;
      }
    }
  }
}

export default Order;
